import React from "react";
import Adminnav from "../Adminnav";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BaseURL from "../../Util/BaseURL";
const AllOrders = () => {
  var nav = useNavigate();
  const [orders, setorders] = useState();
  async function getOrders() {
    const r = await axios.get(`${BaseURL}getAllOrders`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    setorders(r.data);
  }

  function ordersummary(props) {
    nav("/OrderSummary", { state: { orderNo: props } });
  }
  useEffect(() => {
    getOrders();
  }, []);
  return (
    <>
      <Adminnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">All Orders</h1>
          </div>
        </div>
      </section>
      <section className="">
        <div className="container">
          <div className="cart">
            <div className="table-responsive">
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Order Number
                    </th>
                    <th scope="col" className="text-white">
                      Customer
                    </th>
                    <th scope="col" className="text-white ">
                      Date
                    </th>
                    <th scope="col" className="text-white ">
                      Total Amount
                    </th>
                    <th scope="col" className="text-white ">
                      Total Discount
                    </th>
                    <th scope="col" className="text-white ">
                      Delivery Address
                    </th>
                    <th scope="col" className="text-white ">
                      Payment Method
                    </th>
                    <th scope="col" className="text-white ">
                      Payment Status
                    </th>
                    <th scope="col" className="text-white ">
                      Delivery Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders ? (
                    orders.map((data,key) => (
                        <tr key={key}
                          className="orderslist target"
                          onClick={() => ordersummary(data.orderNumber)}
                        >
                          <td className="productId">{data.orderNumber}</td>
                          <td>{data.username}</td>
                          <td className="quantity">
                            {data.date.substring(5, 16)}
                          </td>
                          <td className="total">{data.totalAmount}</td>
                          <td className="total">{data.totalDiscount}</td>
                          <td className="total">{data.address}</td>
                          <td className="total">{data.payment}</td>
                          <td className="pay">
                            {data.isBilled === true ? <>Paid</> : <>Unpaid</>}
                          </td>
                          <td className="delivery">
                            {data.isBilled === true ? (
                              <>Delivered</>
                            ) : (
                              <>Not Delivered</>
                            )}
                          </td>
                        </tr>
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllOrders;
